import React from "react";
import './demos.css';
import PageTemplate from "../../templates/page-template/PageTemplate";
import DemosContent from "../../organisms/DemosContent/DemosContent";

const Contact: React.FC = () => {
    return (
        <PageTemplate children={<DemosContent/>}></PageTemplate>
    );
};

export default Contact;